import React, {useEffect, useState} from "react";
import {PasswordSavingModalBackground} from "../../../components/ui/Content";
import styled from "styled-components/macro";
import {useAppDispatch} from "../../../app/hooks";
import {hideGlobalAlert} from "../../Alert/slice";
import {ProgressBar} from "./CircleProgressBar";
import {useLocation, useNavigate} from "react-router-dom";

export const PasswordSavingModal = () => {
    const [percents, setPercents] = useState(0)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const {search} = useLocation()
    useEffect(() => {
        setTimeout(() => {
            setPercents((prevState) => ++prevState)
        }, 8.5)
        setTimeout(() => {
            dispatch(hideGlobalAlert())
            navigate(`/sign-in${search}`)
        }, 1000);
    })
    return <>
        <PasswordSavingModalBackground/>
        <LoaderBackground>
            <ProgressBar percentage={percents} color={'#007AFF'}/>
        </LoaderBackground>
    </>
}

const LoaderBackground = styled.div`
  position: absolute;
  display: flex;
  width: 88px;
  height: 88px;
  background: #F7F8FA;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.08), 0 16px 16px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  z-index: 10;
  align-items: center;
  justify-content: center;
`